import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyTransactions } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./TransferTransactionsPage.css";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const truncateHash = (str, head = 8, tail = 6) => {
  if (!str || str.length <= head + tail) return str;
  return `${str.slice(0, head)}...${str.slice(-tail)}`;
};

const TransferTransactionsPage = () => {
  const [transactions] = useState(dummyTransactions);
  const [search, setSearch] = useState("");

  const filtered = transactions.filter(
    (t) =>
      t._id?.toLowerCase().includes(search.toLowerCase()) ||
      t.user_id?.toLowerCase().includes(search.toLowerCase()) ||
      t.transaction_hash?.toLowerCase().includes(search.toLowerCase()) ||
      t.currency?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Transfer Transactions</span>
          </p>
          <h1 className="dashboard-hero__title">Transfer Transactions</h1>
          <p className="dashboard-hero__subtitle">
            View internal transfer transactions
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-exchange-alt" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="transfer-section">
          <div className="transfer-section__header">
            <div className="transfer-section__title-wrap">
              <span className="transfer-section__icon">
                <i className="fas fa-random" />
              </span>
              <h2 className="transfer-section__title">Transfer History</h2>
            </div>
            <div className="transfer-section__stats">
              <span className="transfer-stat">
                <strong>{transactions.length}</strong> Transfers
              </span>
              <span className="transfer-stat">
                <strong>{transactions.filter((t) => t.status === "Completed").length}</strong> Completed
              </span>
            </div>
          </div>
          <div className="transfer-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by ID, user ID, tx hash or currency..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="transfer-search-input"
            />
          </div>
          <div className="transfer-table-wrap">
            <table className="transfer-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Created</th>
                  <th>User ID</th>
                  <th>Chain</th>
                  <th>Currency</th>
                  <th>Amount</th>
                  <th>Fee</th>
                  <th>From Address</th>
                  <th>To Address</th>
                  <th>Tx Hash</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row) => (
                  <tr key={row._id}>
                    <td><span className="transfer-mono">{row._id}</span></td>
                    <td>{formatDate(row.createdAt)}</td>
                    <td><span className="transfer-mono">{row.user_id}</span></td>
                    <td>{row.chain}</td>
                    <td><strong>{row.currency}</strong></td>
                    <td>{typeof row.amount === "number" ? row.amount.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.amount}</td>
                    <td>{typeof row.fee === "number" ? row.fee.toLocaleString("en-IN", { minimumFractionDigits: 4 }) : row.fee}</td>
                    <td><span className="transfer-hash" title={row.from_address}>{truncateHash(row.from_address)}</span></td>
                    <td><span className="transfer-hash" title={row.to_address}>{truncateHash(row.to_address)}</span></td>
                    <td><span className="transfer-hash" title={row.transaction_hash}>{truncateHash(row.transaction_hash, 10, 8)}</span></td>
                    <td>
                      <span className={`transfer-status transfer-status--${(row.status || "").toLowerCase()}`}>
                        {row.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtered.length === 0 && (
            <p className="transfer-empty">No transfer transactions match your search.</p>
          )}
        </section>
      </div>
    </main>
  );
};

export default TransferTransactionsPage;
